import { ColDef } from 'ag-grid-community';
import { AgGridTable } from '@shared/components/ui/AgGridTable';
import { Manifest } from '../../models';

interface ManifestsAgGridTableProps {
  manifests: Manifest[];
  columnDefs: ColDef[];
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  isFetching?: boolean;
  sorting?: { field: string; direction: 'asc' | 'desc' } | null;
  onSortingChange?: (
    sorting: { field: string; direction: 'asc' | 'desc' } | null
  ) => void;
}

export const ManifestsAgGridTable = ({
  manifests,
  columnDefs,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  isFetching,
  sorting,
  onSortingChange,
}: ManifestsAgGridTableProps) => {
  const shouldDim = Boolean(isFetching && !isFetchingNextPage);

  return (
    <div
      className={`w-full transition-opacity duration-300 ${
        shouldDim ? 'opacity-50 pointer-events-none' : ''
      }`}
    >
      <AgGridTable
        data={manifests}
        columnDefs={columnDefs}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        enableSelection={false}
        sorting={sorting ?? null}
        onSortingChange={onSortingChange}
        className="rounded-lg shadow-sm"
        height="calc(100vh - 150px)"
      />
    </div>
  );
};
